import { Injectable } from '@angular/core';
import moment from 'moment';
import { FPAppointmentsSearchDto, FPAppointmentsSearchResultDto } from 'webcommon/shared';
import { FacilityPortalHttpClientService } from '../FacilityPortalHttpClientService';

@Injectable({
  providedIn: 'root',
})
export class FpAppointmentsRepository {
  constructor(
    private httpClientService: FacilityPortalHttpClientService,
  ) {

  }

  getAppointmentForPatient(searchDto: FPAppointmentsSearchDto) {
    const endpointUrl = 'appointments-patient';
    const body = {
      ...searchDto,
      DateOfBirth: searchDto.DateOfBirth && moment.utc(searchDto.DateOfBirth).format('MM/DD/YYYY'),
      StartDate: searchDto.StartDate && moment.utc(searchDto.StartDate).format('MM/DD/YYYY'),
      EndDate: searchDto.EndDate && moment.utc(searchDto.EndDate).format('MM/DD/YYYY'),
    };
    return this.httpClientService.sendPostRequest<FPAppointmentsSearchResultDto[]>(endpointUrl, body);
  }
}
